import { configureStore } from '@reduxjs/toolkit'
import authReducer from "./userSlice"
import icoReducer from "./icoSlice"


export const store = configureStore({
  reducer: {
    authSlice: authReducer,
    ico: icoReducer,
  },
})